import React from 'react'
import { EmptyState } from '@enamelai/design-system'
import './InsuranceEmptyCard.css'

type InsuranceEmptyCardProps = {
  iconClass: string
  emptyTitle: string
  description: string
  actionText?: string
  onAction?: () => void
  /** Border when 2+ empty states share a blue page. Single empty states stay unoutlined. */
  outlined?: boolean
}

function InsuranceEmptyCard({
  iconClass,
  emptyTitle,
  description,
  actionText,
  onAction,
  outlined = false,
}: InsuranceEmptyCardProps): React.ReactElement {
  return (
    <div className="insurance-empty-card">
      <EmptyState
        className="insurance-empty-card__state"
        iconClass={iconClass}
        title={emptyTitle}
        description={description}
        actionLabel={actionText}
        onAction={onAction}
        outlined={outlined}
      />
    </div>
  )
}

export default InsuranceEmptyCard
